export const state = {
  isCollapsed: false,
  isShowWidget: false,
  calls: [],
  isMuted: false,
}

export const getters = {
  vehicleIdsCallActive: (state) => {
    return state.calls.map((call) => call.vehicleId)
  },
  sumCallsActive: (state) => {
    return state.calls.length
  },
}

export const actions = {
  startNewCall(
    { commit },
    {
      dataNewCall: {
        vehicleId,
        licensePlate,
        driver,
        imei,
        deviceType,
        entryPoint,
        isDebugBroadcast,
      },
      isAutoReconnect = false,
      isBroadcast = false,
    }
  ) {
    commit('addCalls', {
      vehicleId,
      licensePlate,
      driver,
      imei,
      deviceType,
      entryPoint,
      isDebugBroadcast,
    })
    if (isAutoReconnect) return
    let callsActive
    if (!window.localStorage.getItem('voipActive')) {
      callsActive = []
    } else {
      callsActive = JSON.parse(window.localStorage.getItem('voipActive'))
    }

    const mergedCalls = [
      ...callsActive,
      { vehicleId, licensePlate, driver: driver ?? null, imei, deviceType },
    ]
    if (!isBroadcast) {
      window.localStorage.setItem('voipActive', JSON.stringify(mergedCalls))
    }
  },
}

export const mutations = {
  setIsCollapsed(state, payload) {
    state.isCollapsed = payload
  },
  setIsShowWidget(state, payload) {
    state.isShowWidget = payload
  },
  addCalls(
    state,
    { vehicleId, licensePlate, driver, imei, deviceType, entryPoint, isDebugBroadcast }
  ) {
    const tempCalls = [
      ...state.calls,
      { vehicleId, licensePlate, driver, imei, deviceType, entryPoint, isDebugBroadcast },
    ]
    state.calls = tempCalls
  },
  removeCalls(state, vehicleId) {
    const tempCalls = state.calls.filter((call) => vehicleId !== call.vehicleId)
    state.calls = tempCalls
  },
  toggleMuted(state) {
    state.isMuted = !state.isMuted
  },
  setIsMuted(state, payload) {
    state.isMuted = payload
  },
}
